.audioPlayer {
  min-width: 300px;
}
.audioPlayer::-webkit-media-controls-panel, .audioPlayer::-webkit-media-controls-enclosure {
  background-color: rgba(200, 200, 200, 0.3);
}

.hiddenAudio {
  display: none;
}

.customControls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 300px;
}
@media (max-width: 500px) {
  .customControls {
    min-width: min(70vw, 340px);
  }
}

.customControlsCompact {
  min-width: 0;
}

.stack {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.metaRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.seekWrap {
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  height: 32px;
}

.seek {
  flex: 1;
  min-width: 0;
  accent-color: var(--colorPrimary);
}

.waveformCanvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.seekOverWaveform {
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  accent-color: transparent;
  height: 32px;
}
.seekOverWaveform::-webkit-slider-runnable-track {
  background: transparent;
}
.seekOverWaveform::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 0;
  height: 0;
}
.seekOverWaveform::-moz-range-track {
  background: transparent;
}
.seekOverWaveform::-moz-range-thumb {
  width: 0;
  border: none;
  opacity: 0;
}

.time {
  font-size: 0.85em;
  font-variant-numeric: tabular-nums;
}

.speedPill {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  border: 1px solid currentColor;
  border-radius: 9999999px;
  padding: 0.1rem 0.5rem;
  font-size: 0.85em;
  line-height: 1.2;
}